import { API_ENDPOINT } from "@/constants/appConstants";

import {
  OutreachUnsubscribeDetails,
  UnsubscribeFormData,
} from "./types/unsubscribe";

export const unSubscribeOutReachAPI = async <T>(
  body?: UnsubscribeFormData,
): Promise<T | Error> => {
  try {
    const host = window.location.host;

    const response = await fetch(
      `${API_ENDPOINT(host).middleware.updateOutreachSubscription}`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      },
    );

    const data = await response.json();

    return { ...data, status: response.status };
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while updating outreach subscription, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const fetchUnSubscribeOutReachDataAPI = async (
  corpId?: string,
): Promise<OutreachUnsubscribeDetails> => {
  try {
    const corp_id = corpId ? `?corpId=${corpId}` : "";
    const host = window.location.host;
    const response = await fetch(
      `${API_ENDPOINT(host).middleware.getOutreachSubscription}${corp_id}`,
      {
        method: "GET",
        credentials: "include",
      },
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching outreach subscription data: ${response.statusText}`,
      );
    }

    const data: OutreachUnsubscribeDetails = await response.json();

    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};
